var React = require('react');

function SearchInline (props) {
    return React.createElement("svg",props,[React.createElement("title",{"key":0},"Search"),React.createElement("circle",{"cx":"42.98","cy":"42.98","r":"33.18","fill":"none","stroke":"#fff","strokeLinecap":"round","strokeLinejoin":"round","strokeWidth":"19.6","key":1}),React.createElement("path",{"d":"M68,69.91,92.39,93.78","fill":"none","stroke":"#fff","strokeLinecap":"round","strokeLinejoin":"round","strokeWidth":"23.16","key":2})]);
}

SearchInline.defaultProps = {"viewBox":"0 0 103.97 105.36"};

module.exports = SearchInline;

SearchInline.default = SearchInline;
